import { FunctionComponent, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/ui/icon'

const PageHeader: FunctionComponent<{
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  back?: { to: string; label: string }
}> = ({ title, subtitle, actions, back }) => (
  <>
    {back && (
      <Link to={back.to} className="back-link">
        <Icon name="back" size={12} />
        {back.label}
      </Link>
    )}
    <div className="page-head">
      <div>
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions}
    </div>
  </>
)

export default PageHeader
